import React, { useEffect } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import { CancelCheckBox } from 'UI/res/icons/custom';

/**
 * @typedef {Object} CheckboxListProps
 * @property {string[]} checklist
 * @property {FormContextValues} form
 * @property {string} name
 * @property {Function} customValidation
 * @property {true} required
 * @property {'normal' | 'remove'} variant
 */

const checkSize = 20;
const OutlineCheck = () => {
  return <CheckBoxOutlineBlankIcon style={{ width: checkSize, height: checkSize }} />;
};

/**
 * @param {CheckboxListProps} props
 */
const CheckboxList = ({
  checklist,
  customValidation,
  form,
  labelTitle,
  name,
  required,
  variant
}) => {
  const { register, unregister, watch, setValue, errors } = form;

  useEffect(() => {
    register(
      { name },
      { required: required && 'select at least one option', validate: customValidation }
    );
    return () => unregister(name);
  }, [customValidation, name, register, required, unregister]);

  const selectedFields = watch(name, []);
  const handleCheckChange = event => {
    const { name: nameValue, checked } = event.target;
    const fields = checked
      ? [...selectedFields, nameValue]
      : selectedFields.filter(field => field !== nameValue);
    setValue(name, [...new Set(fields)], true);
  };

  const getTypeCheckbox = currentName => {
    switch (variant) {
      case 'remove':
        return (
          <Checkbox
            name={currentName}
            icon={<OutlineCheck />}
            checkedIcon={<CancelCheckBox size={checkSize} />}
          />
        );
      default:
        return <Checkbox name={currentName} />;
    }
  };

  return (
    <FormControl component="fieldset" error={!!errors[name]}>
      <FormLabel component="legend" error={!!errors[name]}>
        {labelTitle}
      </FormLabel>
      <FormGroup aria-label={name} name={name} onChange={handleCheckChange}>
        {checklist &&
          checklist.map(each => (
            <FormControlLabel key={each} label={each} value="end" control={getTypeCheckbox(each)} />
          ))}
        <FormHelperText>{errors[name]?.message}</FormHelperText>
      </FormGroup>
    </FormControl>
  );
};

CheckboxList.defaultProps = {
  required: true,
  variant: 'normal',
  checklist: []
};

export default CheckboxList;
